























import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { Team } from "@/models/team.model";

@Component({
  name: "MyTeamsListItem"
})
export default class MyTeamsListItem extends Vue {
  @Prop({ required: true }) team!: Team;
}
